export default __webpack_public_path__ + "media/e65da686b05d22c31daf1188e1d21de1eb92d65e0b128d42ad81b81d1d20a2f3.svg";